import clsx from 'clsx';
import React from 'react';

import PlaceholderAvatar from './placeholder-avatar';
import PlaceholderDisplayName from './placeholder-display-name';
import PlaceholderStatusContent from './placeholder-status-content';

interface IPlaceholderStatus {
  variant?: 'rounded' | 'slim' | 'default';
}

/** Fake status to display while data is loading. */
const PlaceholderStatus: React.FC<IPlaceholderStatus> = React.memo(({ variant = 'rounded' }) => (
  <div
    className={clsx({
      'status-placeholder bg-white black:bg-black dark:bg-primary-900': true,
      'px-4 py-6 shadow-xl dark:shadow-none sm:rounded-xl sm:p-5': variant === 'rounded',
      'py-4': variant === 'slim',
    })}
  >
    <div className='w-full overflow-hidden no-reduce-motion:animate-pulse'>
      <div>
        <div className='flex items-center gap-3'>
          <div className='shrink-0'>
            <PlaceholderAvatar size={42} />
          </div>

          <div className='min-w-0 flex-1'>
            <PlaceholderDisplayName minLength={3} maxLength={25} />
          </div>
        </div>
      </div>

      <div className='status__content-wrapper mt-4'>
        <PlaceholderStatusContent minLength={5} maxLength={120} />
      </div>
    </div>
  </div>
));

PlaceholderStatus.displayName = 'PlaceholderStatus';

export { PlaceholderStatus as default };
